export const GET_DATA_LOADING = "get/data/loading";
export const GET_DATA_SUCCESS = "get/data/success";
export const GET_DATA_ERROR = "get/data/error";

export const ADD_DATA_LOADING = "add/data/loading";
export const ADD_DATA_SUCCESS = "add/data/success";
export const ADD_DATA_ERROR = "add/data/error";

export const DELETE_DATA_LOADING = "delete/data/loading";
export const DELETE_DATA_SUCCESS = "delete/data/success";
export const DELETE_DATA_ERROR = "delete/data/error";
